import { render, staticRenderFns } from "./FakeCard.vue?vue&type=template&id=72d4aa26"
import script from "./FakeCard.vue?vue&type=script&lang=js"
export * from "./FakeCard.vue?vue&type=script&lang=js"
import style0 from "./FakeCard.vue?vue&type=style&index=0&id=72d4aa26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports